import { IArchiveContentProps } from  '@/interfaces/activityFeed';
import { CancelConfirmModal } from 'thrive-components';
import ArchiveContentPanel from './ArchiveContentPanel';

//hooks
import UseArchiveContent, { ArchiveContentConstants } from './ArchiveContent.hooks';


const ArchiveContent = ({showModal, onCloseClick, onConfirmClick, existsInMultiplePlaces, isInlineStyle}: IArchiveContentProps) => {

    const {archivalQuestion, handleCancelClick, handleConfirmClick} = UseArchiveContent({showModal, onCloseClick, onConfirmClick, existsInMultiplePlaces});
    const {title, cancelButtonText, cancelButtonAriaLabel, confirmButtonText, confirmButtonAriaLabel} = ArchiveContentConstants;
    
    if (!showModal) {
        return <></>
    }

    if (isInlineStyle) {
        return (
            <ArchiveContentPanel 
                existsInMultiplePlaces={existsInMultiplePlaces} 
                title={title} 
                archivalQuestion={archivalQuestion} 
                cancelButtonText={cancelButtonText} 
                cancelButtonAriaLabel={cancelButtonAriaLabel} 
                confirmButtonText={confirmButtonText} 
                confirmButtonAriaLabel={confirmButtonAriaLabel} 
                handleCancelClick={handleCancelClick} 
                handleConfirmClick={handleConfirmClick}            
            />
        )
    }
    
    return (
        <CancelConfirmModal 
            headerContent={title}
            bodyContent={archivalQuestion}
            onCloseClick={onCloseClick}
            cancelButtonText={cancelButtonText}
            cancelButtonAriaLabel={cancelButtonAriaLabel}
            confirmButtonText={confirmButtonText}
            confirmButtonAriaLabel={confirmButtonAriaLabel}
            onCancelClick={onCloseClick} 
            onConfirmClick={onConfirmClick}
        />
    );
};
export default ArchiveContent